import React, { useState, useRef, useEffect } from 'react'

const CustomSlider = ({ min, max, change, defaultValue }) => {
  const innerMax = max + 10
  const innerMin = min + 10
  const [value, setValue] = useState(innerMin)
  const [isDragging, setIsDragging] = useState(false)
  const sliderRef = useRef(null)

  useEffect(() => {
    setValue(Number(defaultValue) + 10)
  }, [defaultValue])

  const updateValue = (clientX) => {
    const rect = sliderRef.current.getBoundingClientRect()
    const x = clientX - rect.left
    let newValue = innerMin + (x / rect.width) * (innerMax - innerMin)
    if (newValue < innerMin) newValue = innerMin
    if (newValue > innerMax) newValue = innerMax
    setValue(newValue)
    change(String(newValue - 10))
  }

  const handleMouseDown = (event) => {
    setIsDragging(true)
    updateValue(event.clientX)
  }

  const handleMouseMove = (event) => {
    if (!isDragging) return
    updateValue(event.clientX)
  }

  const handleMouseUp = () => {
    setIsDragging(false)
  }

  return (
    <div className={' w-full relative select-non'}>
      <div className={'h-[4px] bg-gray-300 w-full absolute top-[50%] translate-y-[-50%] rounded-full '} />

      <div className={' px-[10px] w-full h-full'}>
        <div
          className=" h-[100%] cursor-pointer flex-grow relative w-[100%]"
          ref={sliderRef}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
        >
          <div
            className="absolute bg-primary-500 h-[4px] top-[50%] translate-y-[-50%] rounded-full left-[-10px]"
            style={{ width: `${((value - innerMin) / (innerMax - innerMin)) * 100}%` }}
          />
          <div
            className="absolute w-[20px] h-[20px] bg-primary-500 rounded-full top-[calc(50%-10px)] cursor-pointer shadow-md border-2 border-white "
            style={{
              left: `${((value - innerMin) / (innerMax - innerMin)) * 100}%`,
              transform: 'translateX(-50%)',
            }}
          ></div>
        </div>
      </div>
    </div>
  )
}

export default CustomSlider
